/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Is_Bus_LocationInputs */

const fr_help_is_bus_location = /** @type {(inputs: Help_Is_Bus_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un moyen simple et rapide de voir où se situe son bus.`)
};

const en_help_is_bus_location = /** @type {(inputs: Help_Is_Bus_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A simple and quick way to see where your bus is.`)
};

/**
* | output |
* | --- |
* | "A simple and quick way to see where your bus is." |
*
* @param {Help_Is_Bus_LocationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_is_bus_location = /** @type {((inputs?: Help_Is_Bus_LocationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Is_Bus_LocationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_is_bus_location(inputs)
	return en_help_is_bus_location(inputs)
});